var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRelayOff = function SvgRelayOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2099",
    width: 16,
    height: 16,
    viewBox: "0 0 4.233 4.233",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -292.77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect2644",
    width: 3.969,
    height: 2.91,
    x: 0.132,
    y: 293.43,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    ry: 0.615
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2652",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.529,
    d: "M.236 295.15h.994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2677",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.529,
    d: "M2.97 295.15h.995"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path2679",
    cx: 1.191,
    cy: 295.15,
    r: 0.463,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle3296",
    cx: 3.043,
    cy: 295.15,
    r: 0.463,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3298",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.529,
    d: "m1.418 294.98 1.182-.914"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRelayOff);
export default ForwardRef;